const findLeafGroups = ({ groups }) => {
  const leafGroups = groups.filter(
    (g) => !groups.find((g2) => g2.externalParentId === g.externalId)
  )
  if (leafGroups.length) {
    return leafGroups
  } else {
    return groups.filter((g) => g.numberOfUsers)
  }
}

const findIndividualGroup = ({ groups }) => {
  return groups.find(
    (g) =>
      g.numberOfUsers === 1 && g.minimumNumberOfCompletedSurveysRequired === 1
  )
}

const findHighestLevelGroupWhereUserIsAdmin = ({ groups }) => {
  const adminGroups = groups.filter((g) => g.userIsAdmin)
  return (
    adminGroups.find((g) => {
      return !adminGroups.find((g2) => g2.externalId === g.externalParentId)
    }) || adminGroups[0]
  )
}

export const determineGroupToLoadFirst = ({
  groups,
  details,
  userIsGroupAdmin = false,
  userIsPulsAdmin = false
}) => {
  const individualGroupFound = findIndividualGroup({ groups })
  if (individualGroupFound && !userIsPulsAdmin) {
    return individualGroupFound
  } else {
    if (userIsPulsAdmin) {
      if (details.config?.excludeOrganizationStatistics) {
        return groups.find((g) => g.numberOfUsers) // first non-org group
      } else {
        return null
      }
    } else if (userIsGroupAdmin) {
      const g = findHighestLevelGroupWhereUserIsAdmin({ groups })
      return g
    } else {
      // normal user
      return findLeafGroups({ groups })[0]
    }
  }
}
